import { generate as generateFace, type FaceConfig } from "facesjs";
import { idb } from "../db/index.ts";
import type { PlayerWithoutKey, Race } from "../../../common/types.ts";
import { DEFAULT_JERSEY } from "../../../common/constants.ts";
import g from "./g.ts";
import defaultGameAttributes from "../../../common/defaultGameAttributes.ts";

type PlayerWithLegacyFace = PlayerWithoutKey & {
	face2?: PlayerWithoutKey["face"];
};

export const generate = (
	options:
		| { race?: Race; relative?: undefined }
		| { race?: undefined; relative?: FaceConfig } = {},
) => {
	const overrides = {
		jersey: {
			id: DEFAULT_JERSEY,
		},
	};

	// Careful, because this can be called from the team editor before a league is created
	const gender = Object.hasOwn(g, "gender")
		? g.get("gender")
		: defaultGameAttributes.gender;

	let face = generateFace(overrides, {
		gender,
		...options,
	});

	while (
		face.accessories.id.startsWith("hat") ||
		face.accessories.id === "eye-black" ||
		face.accessories.id === "santa-hat"
	) {
		face = generateFace(overrides, {
			gender,
			...options,
		});
	}

	return face;
};

export const upgrade = async (p: PlayerWithoutKey) => {
	// eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
	if (!p.face || !p.face.accessories) {
		const playerWithLegacyFace: PlayerWithLegacyFace = p;
		playerWithLegacyFace.face2 = p.face;
		p.face = generate();
		await idb.cache.players.put(p);
	}
};
